<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-row>
          <a-col :span="24">
            <a-form-item :label="$t('label.contractID')" :labelCol="labelCol" :wrapperCol="wrapperCol">

              <a-select :placeholder="$t('label.pleaseSelectTheContractNumber')" :disabled="isContractCodeDisabled"  @change="conCodeChanged" v-decorator="['code']">
                <a-select-option
                  v-for="item in conCodeList"
                  :key="item.code"
                  :value="item.code">
                  {{ item.code }}
                </a-select-option>
              </a-select>
<!--              <j-search-select-tag :disabled="isContractCodeDisabled" v-decorator="['contractCode']"-->
<!--                                   dict="efs_md_contract,code,code"/>-->
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.materialCommonNameFileNo')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag  :disabled="isMmCodeDisabled"
                                  @change="mmCodeChanged"
                                  v-decorator="['mmCode']"
                                  :triggerChange="true"
                                   :dictCode="dictMmCode"/>
<!--              <j-search-select-tag-option-is-value-text-->
<!--                :disabled="isMmCodeDisabled"-->
<!--                @change="mmCodeChanged"-->
<!--                v-decorator="['mmCode']"-->
<!--                dict="efs_md_company_price_list as t1,mm_name,mm_code,version=(select max(version) from efs_md_company_price_list where t1.mm_code=mm_code) and del_flag='N' and valid_flag='Y'"/>-->

            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.materialCategory')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag :disabled="isMmCategoryDisabled" v-decorator="['mmCategory']"
                                   dict="efs_md_mm_group,name,code"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.materialCommonName')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input :disabled="isMmNameDisabled" v-decorator="['mmName']"  :placeholder="$t('label.pleaseEnterTheCommonNameOfTheMaterial')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.specification')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input :disabled="isSpecDisabled" v-decorator="['spec']" :placeholder="$t('label.pleaseEnterTheSpecification')" ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.model')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input :disabled="isModelDisabled" v-decorator="['model']" :placeholder="$t('label.pleaseEnterTheSpecification')" ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.unitOfMeasurement')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag :disabled="isUnitDisabled" v-decorator="['unit']"
                                   dict="efs_stocking_msur_unit,name,code"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.unitPrice')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['price']" :placeholder="$t('label.pleaseEnterTheUnitPrice')"  style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.description')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['description']" :placeholder="$t('label.pleaseEnterADescription')" ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.validOrNot')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list"  v-decorator="['validFlag',{'initialValue': 'Y'}]" dictCode="sfyx" :placeholder="$t('label.pleaseChooseWhetherItIsValidOrNot')"  :trigger-change="true"/>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </j-modal>
</template>

<script>

  import { getAction, httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
  import JSearchSelectTagOptionIsValueText from '@/components/dict/JSearchSelectTagOptionIsValueText'
  import { getContractByCode } from '@api/api'

  export default {
    name: 'EfsMdContractPriceListDetailModal',
    components: {
      JSearchSelectTag,
      JSearchSelectTagOptionIsValueText
    },
    props: {
      mainId: {
        type: String,
        required: false,
        default: ''
      }
    },
    data() {
      return {
        form: this.$form.createForm(this),
        slotName: 'tableHeader.operation',
        width: 800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        conCodeList:[],//合同
        confirmLoading: false,
        validatorRules: {},
        url: {
          add: '/contractPriceList/efsMdContractPriceList/addEfsMdContractPriceListDetail',
          edit: '/contractPriceList/efsMdContractPriceList/editEfsMdContractPriceListDetail',
          queryByMtrlCodeWithMaxversion : '/companyPriceList/efsMdCompanyPriceList/queryByMtrlCodeWithMaxversion'
        },
        isContractCodeDisabled: false,
        isMmCodeDisabled: false,
        isMmCategoryDisabled: true,
        isMmNameDisabled: true,
        isSpecDisabled: true,
        isModelDisabled: true,
        isUnitDisabled: true,
        dictMmCode: ""
      }
    },
    created() {
    },
    methods: {
      add() {
        getContractByCode({contractCode: ""}).then((res) => {
          if (res.success) {
            this.conCodeList = res.result.efsMdContracts;
          }
        });
        this.edit({})
      },
      edit(record) {
        this.form.resetFields()
        this.model = Object.assign({}, record)
        this.visible = true
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model, 'createBy', 'createTime', 'updateBy', 'updateTime', 'sysOrgCode', 'conCode', 'breedBatchCode', 'settleRelType', 'mmCode', 'mmCategory', 'mmName', 'categoryCode', 'spec', 'model', 'unit', 'price', 'version', 'description', 'companyCode', 'deptCode', 'postDate', 'approvalStatus', 'applicant', 'applyTime', 'lastApprover', 'lastApproveTime', 'dataSource', 'buffer1', 'buffer2', 'buffer3', 'buffer4', 'buffer5', 'buffer6', 'buffer7', 'buffer8', 'buffer9', 'buffer10', 'notes', 'validFlag', 'delFlag', 'tenantCode', 'thirdSysCode', 'syncStatus', 'syncMsg'))
        })
      },
      close() {
        this.$emit('close')
        this.visible = false
        this.isMmCodeDisabled = false
        this.isContractCodeDisabled = false
      },
      handleOk() {
        const that = this
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true
            let httpurl = ''
            let method = ''
            if (!this.model.id) {
              httpurl += this.url.add
              method = 'post'
            } else {
              // httpurl += this.url.edit
              // method = 'put'
              httpurl += this.url.edit
              method = 'put'
            }
            let formData = Object.assign(this.model, values)
            formData['conCode'] = this.mainId
            console.log('表单提交数据', formData)
            httpAction(httpurl, formData, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            }).finally(() => {
              that.confirmLoading = false
              that.close()
            })
          }

        })
      },
      handleCancel() {
        this.close()
      },
      popupCallback(row) {
        this.form.setFieldsValue(pick(row, 'createBy', 'createTime', 'updateBy', 'updateTime', 'sysOrgCode', 'conCode', 'breedBatchCode', 'settleRelType', 'mmCode', 'mmCategory', 'mmName', 'categoryCode', 'spec', 'model', 'unit', 'price', 'version', 'description', 'companyCode', 'deptCode', 'postDate', 'approvalStatus', 'applicant', 'applyTime', 'lastApprover', 'lastApproveTime', 'dataSource', 'buffer1', 'buffer2', 'buffer3', 'buffer4', 'buffer5', 'buffer6', 'buffer7', 'buffer8', 'buffer9', 'buffer10', 'notes', 'validFlag', 'delFlag', 'tenantCode', 'thirdSysCode', 'syncStatus', 'syncMsg'))
      },
      conCodeChanged(param) {
        this.dictMmCode = "view_efs_std_contract_material,mm_name,mm_code,con_code like '" + param + "*' ";
        this.model.mmCode = ''
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model, 'mmCode'))
        })
      },
      mmCodeChanged(param) {
        getAction(this.url.queryByMtrlCodeWithMaxversion, { code: param }).then(res => {
          if (res.success) {
            this.form.resetFields()
            this.form.setFieldsValue({
              mmCode: res.result.mmCode,
              mmCategory: res.result.mmCategory,
              mmName: res.result.mmName,
              spec: res.result.spec,
              model: res.result.model,
              unit: res.result.unit,
              price: res.result.price,
              description: res.result.description,
              validFlag: res.result.validFlag
            })
          } else {
            this.$message.warning(res.message)
          }
        })
      }

    }
  }
</script>
